// Export for tests
export const text = {
  emptyToken: 'Vul een waarde in',
  invalidChar: 'Token mag geen * bevatten',
  duplicateToken: 'Kan niet hetzelfde zijn als een bestaande token',
};

type Args = {
  mainToken: string | null;
  tokensToCompare: Array<string | null>;
};

const validateRealworksToken = ({
  mainToken,
  tokensToCompare,
}: Args): string | true => {
  // Check if main token is empty or null
  if (!mainToken || mainToken.trim() === '') {
    return text.emptyToken;
  }

  const containsInvalidChar = mainToken.includes('*');
  if (containsInvalidChar) {
    return text.invalidChar;
  }

  // Filter out null values and empty strings from comparison tokens
  const validTokens = tokensToCompare.filter(
    (token): token is string => token !== null && token.trim() !== '',
  );

  // Check for duplicates with valid tokens
  const isDuplicate = validTokens.some(token => token === mainToken);
  if (isDuplicate) {
    return text.duplicateToken;
  }

  return true;
};

export default validateRealworksToken;
